// src/context/toast/toast.actions.js
export const toastActionTypes = {
  SHOW_TOAST: 'SHOW_TOAST',
  HIDE_TOAST: 'HIDE_TOAST'
};
